var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettlement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-\\u2013-Assets-and-styles",
    transform: "translate(-1191.000000, -820.000000)",
    fill: "#62A9A9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settlement",
    transform: "translate(1191.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0.03675 12 12.03675 12 12.03675 10.5 0.03675 10.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "6.000075 -0.00015 7.5e-05 1.87485 7.5e-05 3.37485 11.9997 3.37485 11.9997 1.87485"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "1.125 9.5625 3.375 9.5625 3.375 4.3125 1.125 4.3125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "8.625 9.5625 10.875 9.5625 10.875 4.3125 8.625 4.3125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "4.875 9.5625 7.125 9.5625 7.125 4.3125 4.875 4.3125"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlement);
export default __webpack_public_path__ + "static/media/settlement.10fc74edbcc8b41850697815edad24b5.svg";
export { ForwardRef as ReactComponent };